import { ActivityIndicator, ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useRef, useState } from 'react'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Card from '../../shared/card/Card'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { globalStyles } from '../../../static/styles/global'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'

const MoInformationonline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
    } = route.params

    const canvasRef = useRef(null)
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')
    const [isSignatureValid, setIsSignatureValid] = useState(false)
    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postmoonline, modetailsData } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState(false);

    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            filingStatus: values?.filingstatus,
            exemptStatus: values?.exemptstatus ?? null,
            additionalWithholding: values?.additionalamount ? values?.additionalamount : null,
            reducedWithholding: values?.reducedwithholding ? values?.reducedwithholding : null,
            sign: signatureDataURL,
            employersName: modetailsData?.data?.employersName,
            employerAddress: modetailsData?.data?.employerAddress,
            employerCity: modetailsData?.data?.city,
            employerState: modetailsData?.data?.state,
            employerZipCode: modetailsData?.data?.zipCode,
            employerHireDate: modetailsData?.data?.hireDate,
            employerFederalEmployerIDNumber: modetailsData?.data?.federalEmployerIDNumber,
            employerMissouriTaxIdentificationNumber: modetailsData?.data?.taxIdentificationNumber
        }
        const response = await postmoonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MO Withholding Taxation'}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('MoInformationform', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}

export default MoInformationonline

